import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import {
  salesRepsService,
  CreateSalesRepInput,
  UpdateSalesRepInput,
} from "../../services/admin/salesreps.service";

export function useSalesRepsAdmin() {
  return useQuery({
    queryKey: ["admin", "sales-reps"],
    queryFn: salesRepsService.getAll,
  });
}

export function useSalesRep(id?: string) {
  return useQuery({
    queryKey: ["admin", "sales-reps", id],
    queryFn: () => salesRepsService.getById(id!),
    enabled: !!id,
  });
}

export function useCreateSalesRep() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateSalesRepInput) => salesRepsService.create(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "sales-reps"] });
      queryClient.invalidateQueries({ queryKey: ["sales-reps"] });
      notifications.show({
        title: "Success",
        message: "Sales Rep created successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.message || "Failed to create sales rep",
        color: "red",
      });
    },
  });
}

export function useUpdateSalesRep() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateSalesRepInput) => salesRepsService.update(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "sales-reps"] });
      queryClient.invalidateQueries({ queryKey: ["sales-reps"] });
      notifications.show({
        title: "Success",
        message: "Sales Rep updated successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.message || "Failed to update sales rep",
        color: "red",
      });
    },
  });
}

export function useDeleteSalesRep() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => salesRepsService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "sales-reps"] });
      queryClient.invalidateQueries({ queryKey: ["sales-reps"] });
      notifications.show({
        title: "Success",
        message: "Sales Rep deleted successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.message || "Failed to delete sales rep",
        color: "red",
      });
    },
  });
}
